<template>
    <Head title="Email Verification" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
        </div>

        <div class="mb-4 text-sm text-gray-600">
            Thanks for signing up in Sistem Pengadaan Barang dan Jasa Universitas Diponegoro, Before getting started please
            verify your email address.
        </div>

        <div
            class="mb-4 font-medium text-sm text-green-600"
            v-if="$page.props.flashdata.inertia_req_stts_ok"
        >
            A new verification link has been sent to the email address you
            provided during registration.
        </div>

        <div
            class="mb-4 font-medium text-sm text-red-600"
            v-if="$page.props.flashdata.inertia_req_stts_ko"
        >
            An error occurred during processing. Please try again.
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <jet-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Resend Verification Email
                </jet-button>

<!--                <Link-->
<!--                    :href="route('login')"-->
<!--                    method="post"-->
<!--                    as="button"-->
<!--                    class="underline text-sm text-gray-600 hover:text-gray-900"-->
<!--                    >Log In</Link-->
<!--                >-->
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import JetButton from "@/Jetstream/Button.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoAppSquare,
        JetButton,
        Link,
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                email: this.$page.props.user.email,
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("verification.send"));
        },
    },
});
</script>
